module.exports = __webpack_public_path__ + "static/media/1Price-Match.76bd0d0e.jpeg";